<template>
  <div class="search-widget__results-wrapper">
    <div v-if="hits.length" class="search-widget__results">
      <section class="search-widget__group">
        <ul>
          <li v-for="hit in hits" :key="hit.nid">
            <SimpleSearchResult :key="hit.nid" :result="hit" :query="val" />
          </li>
        </ul>
      </section>
    </div>
    <div class="search-widget__empty" v-else-if="val.length && !loading">
      <p>{{ Drupal.t('sitewide.search.empty') }}</p>
    </div>
    <div class="search-widget__loader" v-else-if="loading">
      <Icon :loading="true" />
    </div>
    <div v-if="type == 'default' || type == 'menu-overlay' && hits.length" class="search-widget__all-results">
      <a :href="`/zoeken?keys=${val}`" class="link">{{ Drupal.t('home.search.all-results') }}</a>
    </div>
  </div>
</template>

<script>
import SimpleSearchResult from '../SimpleSearchResult/SimpleSearchResult.vue';
export default {
  name: 'SearchWidgetResults',
  props: {
    val: {
      type: String,
    },

    type: {
      type: String,
      default: 'default'
    },

    hits: {
      type: Array,
    },

    loading: {
      type: Boolean,
    },
  },
  components: {
    SimpleSearchResult,
  }
}
</script>